import { ServiceOrderState as ServiceOrderStateEnum } from '@mews-commander/data-access';
import { enumify, Enumify } from '@mews/enumify';

function ServiceOrderState() {}
enumify<ServiceOrderStateEnum, number>(ServiceOrderState, 'ServiceOrderState', {
    Inquired: 0,
    Confirmed: 1,
    Started: 2,
    Processed: 3,
    Canceled: 4,
    Optional: 5,
    Requested: 6,
});

export default ServiceOrderState as unknown as Enumify<ServiceOrderStateEnum, number>;
